import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from 'shared/actions/authentication';
import {
  NewbuildingBrokerFlatBanner,
  TNewbuildingBrokerFlatBannerButtonType,
} from 'shared/components/NewbuildingBrokerFlatBanner';
import { selectIsNewbuildingBrokerFlatBannerEnabled } from 'shared/selectors/featureToggle';
import { selectIsAuthenticated } from 'shared/selectors/offerData';

import { NewbuildingBrokerFlatCallbackModalContainerLoadable } from './NewbuildingBrokerFlatCallbackModalContainer';
import { trackFlatBannerClick, trackFlatBannerShow } from './tracking';

export const NewbuildingBrokerFlatBannerContainer: React.FC = () => {
  const [modalOpened, setModalOpened] = React.useState(false);
  const [buttonType, setButtonType] = React.useState<TNewbuildingBrokerFlatBannerButtonType | null>(null);

  const isNewbuildingBrokerFlatBannerEnabled = useSelector(selectIsNewbuildingBrokerFlatBannerEnabled);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(
    (buttonType: TNewbuildingBrokerFlatBannerButtonType) => {
      setButtonType(buttonType);
      trackFlatBannerClick(buttonType);

      if (isAuthenticated) {
        setModalOpened(true);
      } else {
        dispatch(
          requestAuthentication({
            onSuccess: () => () => {
              setModalOpened(true);
            },
          }),
        );
      }
    },
    [isAuthenticated, dispatch],
  );

  const handleModalClose = React.useCallback(() => setModalOpened(false), []);

  if (!isNewbuildingBrokerFlatBannerEnabled) {
    return null;
  }

  return (
    <>
      <ActionAfterViewObserver callback={trackFlatBannerShow}>
        <NewbuildingBrokerFlatBanner onButtonClick={handleButtonClick} />
      </ActionAfterViewObserver>
      {modalOpened && (
        <NewbuildingBrokerFlatCallbackModalContainerLoadable
          forSimilarFlat={buttonType === 'similar'}
          onClose={handleModalClose}
        />
      )}
    </>
  );
};
